interface EntityMapper<T, Y = any> {
  toEntity (data: Y): T
}

abstract class EntityListMapper<T, Y = any> implements EntityMapper<T, Y> {
  abstract toEntity (data: Y): T

  toEntityList (data: Y[]): T[] {
    return data.map((item: Y) => this.toEntity(item)) || []
  }
}

interface RequestMapper<T> {
  toRequest<Y = any> (data: T): Y
}

export interface Mapper<T> extends EntityMapper<T>, RequestMapper<T> {}

export abstract class ListMapper<T, Y = any> extends EntityListMapper<T, Y> {}
